/**
 * Parse `.env` `BASE_URL` to never be with a trailing slash.
 *
 * This lets users add a trailing slash to `.env`, but not
 * break the app in places such as logging out and api calls.
 */
export const getBaseURL = () => {
  return import.meta.env.VITE_BASE_URL?.replace(/\/$/im, '')
}
